import { useEffect } from 'react'

import { loadRecaptchaEnterprise } from '@/infra/recaptcha/recaptcha-enterprise-loader'
import errorMonitor from '@/infra/tracking/error-monitor'
import { settings } from '@/main/config/settings'

/**
 * Habilita a coleta passiva de telemetria horizontal do Account Defender.
 *
 * O Account Defender precisa enxergar a jornada inteira — inclusive as páginas
 * logadas —, não apenas o instante do submit. Carregado só nas telas de auth, ele vê
 * um acesso isolado sem histórico de navegação, que é indistinguível de bot; é
 * exatamente o caso do usuário atrás de VPN corporativa.
 *
 * Este componente apenas carrega o script; nunca chama `execute()`. A geração de token
 * continua sendo responsabilidade do {@link RecaptchaProvider} nas rotas protegidas,
 * que compartilha este mesmo runtime.
 *
 * Deve ser montado no topo da aplicação, fora do router: o script é carregado uma vez
 * por page load e sobrevive a toda navegação.
 */
export const RecaptchaTelemetry = () => {
  useEffect(() => {
    // Desligado por ambiente, ou sem a chave de score configurada, não há nada que
    // alimente o Account Defender.
    if (!settings.RECAPTCHA_ENABLED || !settings.RECAPTCHA_SITE_KEY_V3) {
      return
    }

    loadRecaptchaEnterprise(settings.RECAPTCHA_SITE_KEY_V3).catch((error: unknown) => {
      // Telemetria é best-effort: falhar aqui não pode afetar a aplicação. Os fluxos
      // protegidos chamam o loader por conta própria e tratam o próprio erro.
      errorMonitor.captureException(error, {
        tags: { feature: 'recaptcha-telemetry' },
        level: 'warning'
      })
    })
  }, [])

  return null
}
